import axios from "axios";
import {
  retrieveData,
  removeData,
} from "../LocalConnection/LocalConnection.js";

let APL_LINK = "http://10.100.51.93:8000/";
// let APL_LINK = "http://10.240.30.93:8000/";
APL_LINK = "https://backendpython.kidsfunfactory.in/";

let version_vi_api_admin = APL_LINK + "api/v1/admin/";

const SECRET_KEY = "FUNZONEE_FUNZONE_202";

/* ---------------------- ADMIN API ENDPOINTS ---------------------- */

const login_to_admin = version_vi_api_admin + "login_to_admin";

const get_funzone_dashboard = version_vi_api_admin + "get_funzone_dashboard";

const extend_funzone_session = version_vi_api_admin + "extend_funzone_session";

const save_funzone_billing = version_vi_api_admin + "save_funzone_billing";

const release_funzone_billing =
  version_vi_api_admin + "release_funzone_billing";

const save_funzone_settings = version_vi_api_admin + "save_funzone_settings";

const get_funzone_settings = version_vi_api_admin + "get_funzone_settings";

const get_funzone_reports = version_vi_api_admin + "get_funzone_reports";

const save_contact_us = version_vi_api_admin + "save_contact_us";

const get_contact_us = version_vi_api_admin + "get_contact_us";

const delete_funzone_billing = version_vi_api_admin + "delete_funzone_billing";


const download_printer_setup =
  "https://www.kidsfunfactory.in/UpRestro_Printer1.0.0.exe";

/* ---------------------- LOGOUT FUNCTION ---------------------- */

const logoutAndClearData = () => {
  removeData();
  window.location.href = "/login";
};

/* ---------------------- SERVER POST FUNCTION ---------------------- */

const server_post_data = async (url_for, form_data) => {
  try {
    const retrievedAdminId = retrieveData("admin_id");
    const access_token = retrieveData("access_token");
    let packageName = "default";

    if (form_data === null) {
      form_data = new FormData();
    }

    form_data.append("admin_id", retrievedAdminId);
    form_data.append("platform_type", "funzone");
    form_data.append("app_name", "FunZoneAdmin");

    if (form_data.get("data_call") !== null) {
      form_data.append("call_id", retrievedAdminId);
    }

    const response = await axios.post(url_for, form_data, {
      headers: {
        "X-Package-Name": packageName,

        ...(access_token &&
          access_token !== "1" &&
          url_for !== login_to_admin && {
            Authorization: `Bearer ${access_token}`,
          }),
      },
    });

    return response;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      logoutAndClearData();
    }

    throw error;
  }
};

/* ---------------------- EXPORTS ---------------------- */

export {
  APL_LINK,
  SECRET_KEY,
  server_post_data,
  login_to_admin,
  get_funzone_dashboard,
  extend_funzone_session,
  save_funzone_billing,
  release_funzone_billing,
  save_funzone_settings,
  get_funzone_settings,
  get_funzone_reports,
  save_contact_us,
  get_contact_us,
  delete_funzone_billing,
  download_printer_setup,
};
